/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	PoliJobsProposalEnrollmentDTO,
	PoliJobsProposalEnrollmentDTOFromJSON,
	PoliJobsProposalEnrollmentDTOFromJSONTyped,
	PoliJobsProposalEnrollmentDTOToJSON,
} from "./PoliJobsProposalEnrollmentDTO";

/**
 *
 * @export
 * @interface PoliJobsProposalEnrollmentDTOPagedResponse
 */
export interface PoliJobsProposalEnrollmentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalEnrollmentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalEnrollmentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsProposalEnrollmentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<PoliJobsProposalEnrollmentDTO>}
	 * @memberof PoliJobsProposalEnrollmentDTOPagedResponse
	 */
	data?: Array<PoliJobsProposalEnrollmentDTO> | null;
}

export function PoliJobsProposalEnrollmentDTOPagedResponseFromJSON(
	json: any
): PoliJobsProposalEnrollmentDTOPagedResponse {
	return PoliJobsProposalEnrollmentDTOPagedResponseFromJSONTyped(json, false);
}

export function PoliJobsProposalEnrollmentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsProposalEnrollmentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(PoliJobsProposalEnrollmentDTOFromJSON),
	};
}

export function PoliJobsProposalEnrollmentDTOPagedResponseToJSON(
	value?: PoliJobsProposalEnrollmentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(PoliJobsProposalEnrollmentDTOToJSON),
	};
}
